<div class="container">
  <input
    matInput
    type="text"
    autocomplete="off"
    name="search"
    [formControl]="searchValue"
    (keyup)="handlerChangeSearch()"
    placeholder="Buscar cuenta"
  />
  <div class="search-icon" *ngIf="searchValue.value.length > 0">
    <img class="icon" src="assets/icons/trash-can.svg" (click)="clearSearch()" />
  </div>
</div>
